module.exports = __webpack_public_path__ + "img/tienda.991c3416.png";